// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"BurgerCarouselItem_carouselItem__5s5Mj","imageCard":"BurgerCarouselItem_imageCard__nGStk","burgerTitle":"BurgerCarouselItem_burgerTitle__heo6L"};